import { createReducer } from "typesafe-actions";
import { toStateObject } from "../../lib/helpers";

import { actions } from ".";
import defaultState from "./state";

const usableActions = await actions

export default createReducer(defaultState)
  .handleAction((await actions).fetchLocationState.success, (state, { payload }) => {
    return {
      ...state,
      locationState: {
        ...toStateObject(payload.stateISO, true),
        fetched: true,
        fetching: false,
        error: false,
      },
    };
  })
  .handleAction((await actions).fetchLocationState.request, (state) => {
    return {
      ...state,
      locationState: {
        ...state.locationState,
        fetched: false,
        fetching: true,
        error: false,
      },
    };
  })
  .handleAction((await actions).fetchLocationState.failure, (state) => {
    return {
      ...state,
      locationState: {
        ...state.locationState,
        fetched: false,
        fetching: false,
        error: true,
      },
    };
  })
  .handleAction((await actions).toggleModal, (state) => {
    return {
      ...state,
      modal: !state.modal,
    };
  })
  .handleAction((await actions).setPipa, (state) => {
    return {
      ...state,
      pipaAccepted: true,
    };
  })
  .handleAction((await actions).updateLocationState, (state, { payload }) => {
    return {
      ...state,
      locationState: {
        ...state.locationState,
        ...payload,
      },
    };
  });
